/**
 * @file 协议映射表单路由配置
 * @description 用于定义映射表单相关的路由配置，包括创建表单和管理表单的路由。
 */

const protocolFrom = [

  {
    path: '/protocol/manage',
    name: 'ProtocolManageView',
    component: () => import('@/view/protocol/ProtocolManageView.vue')
  },
  {
    path: '/protocol/create',
    name: 'ProtocolCreateView',
    component: () => import('@/view/protocol/ProtocolCreateView.vue')
  },
  {
    path: '/form/manage',
    name: 'FormManageView',
    component: () => import('@/view/mappingform/FormManageView')
  },
  {
    path: '/form/create',
    name: 'FormCreateView',
    component: () => import('@/view/mappingform/FormCreateView')
  },
]

export default protocolFrom
